import PubSub from 'services/PubSub/';
import UserInfoService from 'services/AccountInfo/';

const actions = {
    setNumber(data) {
        UserInfoService.updateUser( { homePhone: data.phone, tel_update: data.tel_update, tel_update_date: data.tel_update_date } ).then(results => {
            if (results) {
                setTimeout(()=>{
                    PubSub.dispatch('update_phone_user', {
                        results: results
                    });
                },600);
            }
        });
    }
};

export default actions;
